const serviceData = [


  {
    id: 3,
    title: "nous restons avec vous à chaque étape",
    icon: "ri-roadster-line",
    desc: "Notre service clientèle est là pour vous accompagner durant votre voyage, peu importe où et quand vous avez besoin d'aide.",
  },

  {
    id: 4,
    title: "Nous savons que le service dont vous bénéficiez importe au plus haut point",
    icon: "ri-timer-flash-line",
    desc: "C'est pourquoi nous utilisons d'authentiques avis laissés par nos clients, publions les notes qu'ils attribuent aux founisseurs et vous transmettons notre savoir-faire pour vous guider à travers vos meilleures options.",
  },


  {
    id: 6,
    title: "Nous travaillons avec des sociétés de location de voitures partout dans le monde",
    icon: "ri-flight-takeoff-line",
    desc: "Des enseignes de renom aux petits spécialistes locaux – pour vous apporter les véhicules, les choix et les offres qui auront un effet décisif sur votre voyage. Voilà qui change tout !",
  },
];

export default serviceData;
